import type { ReactNode } from 'react';
import { Children, isValidElement } from 'react';

export const calculateCardWidths = (children: ReactNode, layoutWidth: number, spacing: number) =>
    Children.map(children, child => {
        if (!isValidElement(child)) return 0;
        const { proportion } = child.props;

        return (layoutWidth - spacing * (proportion - 1)) / proportion;
    }) || [];
